/**
 * author: Patrick Vyn Badiang
 */
import React, {useEffect, useRef, useState } from "react";
import { Swiper, SwiperSlide } from "swiper/react";
import { Navigation } from "swiper/modules";
import "swiper/css";
import "swiper/css/navigation";
// import styles bundle
import 'swiper/css/bundle';
import Button from "@mui/material/Button";
import IconButton from "@mui/material/IconButton";
import ArrowBackIosNewIcon from "@mui/icons-material/ArrowBackIosNew";
import ArrowForwardIosIcon from "@mui/icons-material/ArrowForwardIos";
import KeyboardArrowUpIcon from '@mui/icons-material/KeyboardArrowUp';
import KeyboardArrowDownIcon from '@mui/icons-material/KeyboardArrowDown';
import { Typography } from "@mui/material";

import { useDirection } from "../../UtilityFunctions";

//Database
// import FormsDatabase from "../../databases/Forms.json";

function FormSwiper() {
  const nextButtonRef = useRef(null);
  const prevButtonRef = useRef(null);
  const direction = useDirection();
  const [FormsData, setFormsData] = useState([]); // State for the fetched events data


  // Fetch forms on component load
    useEffect(() => {
      fetch('https://9v3dtgzcma.execute-api.us-east-1.amazonaws.com/ascend-forms')
        .then((response) => response.json())
        .then((data) => setFormsData(data))
        .catch((error) => console.error(error));
    }, []);
  

  return (
    <div style={{ width: "58%", height: direction === "horizontal" ? "40px" : "120px", position: "relative", overflow: "visible" }}>
      <Swiper
  slidesPerView={direction === "horizontal" ? 3 : 2}
  direction={direction}
  loop={true}
  modules={[Navigation]}
  navigation={{
    nextEl: nextButtonRef.current,
    prevEl: prevButtonRef.current,
  }}
  onInit={(swiper) => {
    swiper.params.navigation.nextEl = nextButtonRef.current;
    swiper.params.navigation.prevEl = prevButtonRef.current;
    swiper.navigation.init();
    swiper.navigation.update();
  }}
  style={{ width: "100%", height: direction === "horizontal" ? "40px" : "120px" }}
>
  {/* Render slides or fallback */}
  {Array.isArray(FormsData) && FormsData.length > 0 ? (
    FormsData.map((item, i) => (
      <SwiperSlide
        key={item.id}
        style={{ display: "flex", justifyContent: "center", alignItems: "center" }}
      >
        <Button
          variant="contained"
          color="primary"
          href={item.link}
          target="_blank"
          sx={{
            width: direction === "horizontal" ? "800px" : "100%",
            height: "40px",
            textTransform: "none",
            overflow: "hidden",
          }}
        >
          <Typography variant="h6" color="black" sx={{
            textOverflow: "ellipsis",
      overflow: "hidden",
      whiteSpace: "nowrap",
      width: "100%",   // important: gives it a constraint
      display: "block" // so the width applies
          }}>
            {item.name}
          </Typography>
        </Button>
      </SwiperSlide>
    ))
  ) : (
    <SwiperSlide>
      <Button
        variant="contained"
        target="_blank"
        sx={{
          width: direction === "horizontal" ? "100%" : "100%",
          height: "40px",
          textTransform: "none",
        }}
      >
      </Button>
    </SwiperSlide>
  )}
</Swiper>


      {/* Navigation Buttons */}
      <IconButton
        ref={prevButtonRef}
        sx={{
          position: "absolute",
          top: direction === "horizontal" ? "50%":  "0%",
          left: direction === "horizontal" ? "-30px" : "0", // Position outside the Swiper container
          width: direction === "horizontal" ? "40px": "stretch",
          transform: "translateY(-50%)",
          zIndex: 10,
          backgroundColor: "transparent",
        //   "&:hover": { backgroundColor: "grey" }, // Optional hover effect
        }}
      >
        {
            direction === "horizontal" ? 
            <ArrowBackIosNewIcon color="primary" sx = {{
                borderRadius: "50%",
                "&:hover": { backgroundColor: "grey" }}} /> 
            : <KeyboardArrowUpIcon color="primary" />
        }
        {/* <ArrowBackIosNewIcon color="primary" /> */}
      </IconButton>

      <IconButton
        ref={nextButtonRef}
        sx={{
          position: "absolute",
          top: direction === "horizontal" ? "50%":  "110%",
          right: direction === "horizontal" ? "-30px" : "0px", // Position outside the Swiper container
          transform: "translateY(-50%)",
          width: direction === "horizontal" ? "40px": "stretch",

          zIndex: 10,
          backgroundColor: "transparent",
          
        }}
      >
        {
            direction === "horizontal" ? 
            <ArrowForwardIosIcon color="primary" sx = {{
                borderRadius: "50%",
                "&:hover": { backgroundColor: "grey" }}} /> 
                : <KeyboardArrowDownIcon color="primary" />
        }
        {/* <ArrowForwardIosIcon color="primary" /> */}
      </IconButton>
    </div>
  );
}

export default FormSwiper;
